export const devIconvar =
  "https://res.cloudinary.com/drucvvo7f/image/upload/v1610933891/New%20Portfolio%20Site/Icons/006-web_coding_wqe6qb.svg";
export const designIconvar =
  "https://res.cloudinary.com/drucvvo7f/image/upload/v1610934029/New%20Portfolio%20Site/Icons/010-device_ausdx0.svg";
export const uxIconvar =
  "https://res.cloudinary.com/drucvvo7f/image/upload/v1610933950/New%20Portfolio%20Site/Icons/018-idea_iuyusn.svg";
export const developerItemsvar = [
  {
    name:
      "Bring applications to life on the front end with modern JavaScript frameworks such as ReactJS and VueJS",
    icon:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1610944681/New%20Portfolio%20Site/Icons/Develop/005-code_rjnkga.svg",
  },
  {
    name:
      "Build API's, connect databases and serve files with NodeJS and popular frameworks such as Express",
    icon:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1610944681/New%20Portfolio%20Site/Icons/Develop/002-cloud_computing_gayk2z.svg",
  },
  {
    name:
      "Languages: HTML5, CSS3, JavaScript, NodeJS, VueJS, TypeScript, Python, Ruby",
    icon:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1610944681/New%20Portfolio%20Site/Icons/Develop/012-files_tl7jub.svg",
  },
  {
    name: "Databases: MongoDB, Firebase CloudStore, Postgress, SQL",
    icon:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1610944681/New%20Portfolio%20Site/Icons/Develop/007-database_oezqwk.svg",
  },
];
export const designerItemsvar = [
  {
    name: "Strong styling skills with CSS3 and modern CSS frameworks",
    icon:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1610945027/New%20Portfolio%20Site/Icons/Design/017-homepage_zrqkcy.svg",
  },
  {
    name: "Experience with TailwindCSS, Bootstrap, SASS, Styled Components",
    icon:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1610945027/New%20Portfolio%20Site/Icons/Design/024-maintenance_twsymo.svg",
  },
  {
    name:
      "Use of design wireframing tools like Figma and Sketch as well as collaborative tools like Trello",
    icon:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1610945028/New%20Portfolio%20Site/Icons/Design/022-layout_isfu9m.svg",
  },
  {
    name:
      "Have worked heavily with version control platforms such as Git, GitHub, and Team Foundation Server (TFS)",
    icon:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611213733/New%20Portfolio%20Site/Icons/Design/014-shared_folder_n1vm3y.svg",
  },
  {
    name:
      "Impliment Agile methodologies throughout project development lifecycle",
    icon:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611003126/New%20Portfolio%20Site/Icons/Design/029-network_jwrdbk.svg",
  },
];
export const uxItemsvar = [
  {
    name: "Five years of client side software experience",
    icon:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1610945450/New%20Portfolio%20Site/Icons/UX/023-login_zqrzrz.svg",
  },
  {
    name: "Knowledge of Design Flows and UX/UI best practices",
    icon:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1610951234/New%20Portfolio%20Site/Icons/UX/049-workflow_tfhix8.svg",
  },
];
